<template>
  <div class="text-center">
    <v-btn
    :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().accentCode" small text outlined
      @click="dialog = !dialog"
    >
    {{$store.getters.getTextMap().create_write_block}}<v-icon
      right :isDark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().btnborderColorCode" small
      >mdi-pen-plus
      </v-icon>
    </v-btn>
    <v-bottom-sheet v-model="dialog">
      <v-sheet
        class="text-center"
        
      >
      <CreateWriteParam :device="device" v-on:close="dialog=false"/>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import CreateWriteParam from '@/components/CreateWriteParam'
export default {
    name:'CreateWriteParamBottomSheet',
    props:['device'],
    components:{
      CreateWriteParam  
    },
    data(){
        return {
            dialog:false
        }
    },
    methods:{
        
    }
}
</script>
<style>
.devc{

    border-radius:20px;

}
</style>